import NextImage, { ImageProps as NextImageProps } from 'next/legacy/image'
import PropTypes from 'prop-types'
import { cloudflareLoader } from '@mc/image-cloudflare'

export type ImageProps = Omit<NextImageProps, 'loader'>

/**
 * @deprecated
 * This optimized image component is built on `next/legacy/image`.
 * It does not correctly support the `priority` prop, meaning that some images
 * marked as `priority` may in fact load with `fetchpriority=low`.
 * If `priority` is not critical to you then this component will continue to work fine.
 * Otherwise, please use the `next/image` component directly, but be aware that it has
 * a different API including not supporting the `layout` prop which we commonly use.
 */
const Image = ({ src, ...props }: ImageProps) => {
  if (!src) return <></>
  return <NextImage {...props} loader={cloudflareLoader} src={src} />
}

Image.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
}

export default Image
